import fetch from 'auth/FetchInterceptor'

const UserService = {}

UserService.fetch = function () {
	return fetch({
		url: '/users',
		method: 'get'
	})
}

UserService.create = function (data) {
	return fetch({
		url: '/users',
		method: 'post',
		data
	})
}

UserService.update = function (data) {
	return fetch({
		url: '/users/' + data.id,
		method: 'put',
		data
	})
}

UserService.delete = function (id) {
	return fetch({
		url: '/users/' + id,
		method: 'delete'
	})
}

export default UserService;